import { LayoutHOC } from 'base/ui/layout/layout';
import { createSurveyReport } from '.';

export const createSurveyReportPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createSurveyReport());
};
